// extracted by mini-css-extract-plugin
module.exports = {"userPraiseChart":"productionCapacity_userPraiseChart__3mWXM","title":"productionCapacity_title__3aKxg"};